module.exports = __webpack_public_path__ + "img/logo-chaokao.a84b9f95.png";